export const newrelicErrorHandler = (error: string): void => {
  if (typeof newrelic !== 'undefined') {
    newrelic.noticeError(error)
  }
}
